export const API_BASE = (import.meta as any).env?.VITE_API_BASE || 'http://localhost:8000';
// Where to send users after successful login (Laravel Inertia dashboard).
// Kept separate from API_BASE because the API and dashboard may live on
// different hosts in production (e.g. powlo.co vs dashboard.powlo.co).
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const DASHBOARD_URL = (import.meta as any).env?.VITE_DASHBOARD_URL || API_BASE;
